// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AffiliateRouteImport } from './routes/affiliate'
import { Route as AffiliatesRouteImport } from './routes/affiliates'
import { Route as AlgebraAiSolverRouteImport } from './routes/algebra-ai-solver'
import { Route as AnalyticsHealthRouteImport } from './routes/analytics-health'
import { Route as BillingRouteImport } from './routes/billing'
import { Route as CalculusAiSolverRouteImport } from './routes/calculus-ai-solver'
import { Route as ClassesRouteImport } from './routes/classes'
import { Route as CoachRouteImport } from './routes/coach'
import { Route as EducationAdminRouteImport } from './routes/education-admin'
import { Route as ExamRouteImport } from './routes/exam'
import { Route as FamilyRouteImport } from './routes/family'
import { Route as FlashcardsRouteImport } from './routes/flashcards'
import { Route as FriendsRouteImport } from './routes/friends'
import { Route as GameRouteImport } from './routes/game'
import { Route as HistoryRouteImport } from './routes/history'
import { Route as IconDiagnosticsRouteImport } from './routes/icon-diagnostics'
import { Route as LoginRouteImport } from './routes/login'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as OriginalityRouteImport } from './routes/originality'
import { Route as PlannerRouteImport } from './routes/planner'
import { Route as PracticeRouteImport } from './routes/practice'
import { Route as PremiumStatusRouteImport } from './routes/premium-status'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ProgressRouteImport } from './routes/progress'
import { Route as QuizRouteImport } from './routes/quiz'
import { Route as ReferralTermsRouteImport } from './routes/referral-terms'
import { Route as ReferralsRouteImport } from './routes/referrals'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RunbookRouteImport } from './routes/runbook'
import { Route as SchoolRouteImport } from './routes/school'
import { Route as SecurityRouteImport } from './routes/security'
import { Route as SecurityRunsRouteImport } from './routes/security-runs'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SnapCapiRouteImport } from './routes/snap-capi'
import { Route as StudentRouteImport } from './routes/student'
import { Route as SubscriptionRouteImport } from './routes/subscription'
import { Route as SubscriptionStatusRouteImport } from './routes/subscription-status'
import { Route as SupportRouteImport } from './routes/support'
import { Route as TeacherRouteImport } from './routes/teacher'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as UpgradeRouteImport } from './routes/upgrade'
import { Route as UsageRouteImport } from './routes/usage'
import { Route as AffiliateIndexRouteImport } from './routes/affiliate.index'
import { Route as AffiliateCodeRouteImport } from './routes/affiliate.$code'
import { Route as AffiliateAnalyticsRouteImport } from './routes/affiliate.analytics'
import { Route as AffiliatePayoutsRouteImport } from './routes/affiliate.payouts'
import { Route as AssignmentsIndexRouteImport } from './routes/assignments.index'
import { Route as AssignmentsAssignmentIdRouteImport } from './routes/assignments.$assignmentId'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as CheckoutReturnRouteImport } from './routes/checkout.return'
import { Route as CoursesIndexRouteImport } from './routes/courses.index'
import { Route as DebugReportTokenRouteImport } from './routes/debug-report/$token'
import { Route as TeacherIndexRouteImport } from './routes/teacher.index'
import { Route as TeacherAiRouteImport } from './routes/teacher.ai'
import { Route as AffiliateStatementIdRouteImport } from './routes/affiliate.statement.$id'
import { Route as CoursesCourseSlugIndexRouteImport } from './routes/courses.$courseSlug.index'
import { Route as CoursesCourseSlugLessonSlugRouteImport } from './routes/courses.$courseSlug.$lessonSlug'
import { Route as TeacherAssignmentsIndexRouteImport } from './routes/teacher.assignments.index'
import { Route as TeacherAssignmentsAssignmentIdRouteImport } from './routes/teacher.assignments.$assignmentId'
import { Route as TeacherAssignmentsNewRouteImport } from './routes/teacher.assignments.new'
import { Route as TeacherClassesIndexRouteImport } from './routes/teacher.classes.index'
import { Route as TeacherClassesClassIdRouteImport } from './routes/teacher.classes.$classId'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AffiliateRoute = AffiliateRouteImport.update({
            id: '/affiliate',path: '/affiliate',getParentRoute: () => rootRouteImport
          })
const AffiliatesRoute = AffiliatesRouteImport.update({
            id: '/affiliates',path: '/affiliates',getParentRoute: () => rootRouteImport
          })
const AlgebraAiSolverRoute = AlgebraAiSolverRouteImport.update({
            id: '/algebra-ai-solver',path: '/algebra-ai-solver',getParentRoute: () => rootRouteImport
          })
const AnalyticsHealthRoute = AnalyticsHealthRouteImport.update({
            id: '/analytics-health',path: '/analytics-health',getParentRoute: () => rootRouteImport
          })
const BillingRoute = BillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => rootRouteImport
          })
const CalculusAiSolverRoute = CalculusAiSolverRouteImport.update({
            id: '/calculus-ai-solver',path: '/calculus-ai-solver',getParentRoute: () => rootRouteImport
          })
const ClassesRoute = ClassesRouteImport.update({
            id: '/classes',path: '/classes',getParentRoute: () => rootRouteImport
          })
const CoachRoute = CoachRouteImport.update({
            id: '/coach',path: '/coach',getParentRoute: () => rootRouteImport
          })
const EducationAdminRoute = EducationAdminRouteImport.update({
            id: '/education-admin',path: '/education-admin',getParentRoute: () => rootRouteImport
          })
const ExamRoute = ExamRouteImport.update({
            id: '/exam',path: '/exam',getParentRoute: () => rootRouteImport
          })
const FamilyRoute = FamilyRouteImport.update({
            id: '/family',path: '/family',getParentRoute: () => rootRouteImport
          })
const FlashcardsRoute = FlashcardsRouteImport.update({
            id: '/flashcards',path: '/flashcards',getParentRoute: () => rootRouteImport
          })
const FriendsRoute = FriendsRouteImport.update({
            id: '/friends',path: '/friends',getParentRoute: () => rootRouteImport
          })
const GameRoute = GameRouteImport.update({
            id: '/game',path: '/game',getParentRoute: () => rootRouteImport
          })
const HistoryRoute = HistoryRouteImport.update({
            id: '/history',path: '/history',getParentRoute: () => rootRouteImport
          })
const IconDiagnosticsRoute = IconDiagnosticsRouteImport.update({
            id: '/icon-diagnostics',path: '/icon-diagnostics',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const NotificationsRoute = NotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => rootRouteImport
          })
const OnboardingRoute = OnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => rootRouteImport
          })
const OriginalityRoute = OriginalityRouteImport.update({
            id: '/originality',path: '/originality',getParentRoute: () => rootRouteImport
          })
const PlannerRoute = PlannerRouteImport.update({
            id: '/planner',path: '/planner',getParentRoute: () => rootRouteImport
          })
const PracticeRoute = PracticeRouteImport.update({
            id: '/practice',path: '/practice',getParentRoute: () => rootRouteImport
          })
const PremiumStatusRoute = PremiumStatusRouteImport.update({
            id: '/premium-status',path: '/premium-status',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ProgressRoute = ProgressRouteImport.update({
            id: '/progress',path: '/progress',getParentRoute: () => rootRouteImport
          })
const QuizRoute = QuizRouteImport.update({
            id: '/quiz',path: '/quiz',getParentRoute: () => rootRouteImport
          })
const ReferralTermsRoute = ReferralTermsRouteImport.update({
            id: '/referral-terms',path: '/referral-terms',getParentRoute: () => rootRouteImport
          })
const ReferralsRoute = ReferralsRouteImport.update({
            id: '/referrals',path: '/referrals',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const RunbookRoute = RunbookRouteImport.update({
            id: '/runbook',path: '/runbook',getParentRoute: () => rootRouteImport
          })
const SchoolRoute = SchoolRouteImport.update({
            id: '/school',path: '/school',getParentRoute: () => rootRouteImport
          })
const SecurityRoute = SecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => rootRouteImport
          })
const SecurityRunsRoute = SecurityRunsRouteImport.update({
            id: '/security-runs',path: '/security-runs',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const SnapCapiRoute = SnapCapiRouteImport.update({
            id: '/snap-capi',path: '/snap-capi',getParentRoute: () => rootRouteImport
          })
const StudentRoute = StudentRouteImport.update({
            id: '/student',path: '/student',getParentRoute: () => rootRouteImport
          })
const SubscriptionRoute = SubscriptionRouteImport.update({
            id: '/subscription',path: '/subscription',getParentRoute: () => rootRouteImport
          })
const SubscriptionStatusRoute = SubscriptionStatusRouteImport.update({
            id: '/subscription-status',path: '/subscription-status',getParentRoute: () => rootRouteImport
          })
const SupportRoute = SupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => rootRouteImport
          })
const TeacherRoute = TeacherRouteImport.update({
            id: '/teacher',path: '/teacher',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const UpgradeRoute = UpgradeRouteImport.update({
            id: '/upgrade',path: '/upgrade',getParentRoute: () => rootRouteImport
          })
const UsageRoute = UsageRouteImport.update({
            id: '/usage',path: '/usage',getParentRoute: () => rootRouteImport
          })
const AffiliateIndexRoute = AffiliateIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AffiliateRoute
          })
const AffiliateCodeRoute = AffiliateCodeRouteImport.update({
            id: '/$code',path: '/$code',getParentRoute: () => AffiliateRoute
          })
const AffiliateAnalyticsRoute = AffiliateAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => AffiliateRoute
          })
const AffiliatePayoutsRoute = AffiliatePayoutsRouteImport.update({
            id: '/payouts',path: '/payouts',getParentRoute: () => AffiliateRoute
          })
const AssignmentsIndexRoute = AssignmentsIndexRouteImport.update({
            id: '/assignments/',path: '/assignments/',getParentRoute: () => rootRouteImport
          })
const AssignmentsAssignmentIdRoute = AssignmentsAssignmentIdRouteImport.update({
            id: '/assignments/$assignmentId',path: '/assignments/$assignmentId',getParentRoute: () => rootRouteImport
          })
const AuthCallbackRoute = AuthCallbackRouteImport.update({
            id: '/auth/callback',path: '/auth/callback',getParentRoute: () => rootRouteImport
          })
const CheckoutReturnRoute = CheckoutReturnRouteImport.update({
            id: '/checkout/return',path: '/checkout/return',getParentRoute: () => rootRouteImport
          })
const CoursesIndexRoute = CoursesIndexRouteImport.update({
            id: '/courses/',path: '/courses/',getParentRoute: () => rootRouteImport
          })
const DebugReportTokenRoute = DebugReportTokenRouteImport.update({
            id: '/debug-report/$token',path: '/debug-report/$token',getParentRoute: () => rootRouteImport
          })
const TeacherIndexRoute = TeacherIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => TeacherRoute
          })
const TeacherAiRoute = TeacherAiRouteImport.update({
            id: '/ai',path: '/ai',getParentRoute: () => TeacherRoute
          })
const AffiliateStatementIdRoute = AffiliateStatementIdRouteImport.update({
            id: '/statement/$id',path: '/statement/$id',getParentRoute: () => AffiliateRoute
          })
const CoursesCourseSlugIndexRoute = CoursesCourseSlugIndexRouteImport.update({
            id: '/courses/$courseSlug/',path: '/courses/$courseSlug/',getParentRoute: () => rootRouteImport
          })
const CoursesCourseSlugLessonSlugRoute = CoursesCourseSlugLessonSlugRouteImport.update({
            id: '/courses/$courseSlug/$lessonSlug',path: '/courses/$courseSlug/$lessonSlug',getParentRoute: () => rootRouteImport
          })
const TeacherAssignmentsIndexRoute = TeacherAssignmentsIndexRouteImport.update({
            id: '/assignments/',path: '/assignments/',getParentRoute: () => TeacherRoute
          })
const TeacherAssignmentsAssignmentIdRoute = TeacherAssignmentsAssignmentIdRouteImport.update({
            id: '/assignments/$assignmentId',path: '/assignments/$assignmentId',getParentRoute: () => TeacherRoute
          })
const TeacherAssignmentsNewRoute = TeacherAssignmentsNewRouteImport.update({
            id: '/assignments/new',path: '/assignments/new',getParentRoute: () => TeacherRoute
          })
const TeacherClassesIndexRoute = TeacherClassesIndexRouteImport.update({
            id: '/classes/',path: '/classes/',getParentRoute: () => TeacherRoute
          })
const TeacherClassesClassIdRoute = TeacherClassesClassIdRouteImport.update({
            id: '/classes/$classId',path: '/classes/$classId',getParentRoute: () => TeacherRoute
          })





const AffiliateRouteChildren = {
  AffiliateCodeRoute: AffiliateCodeRoute,AffiliateAnalyticsRoute: AffiliateAnalyticsRoute,AffiliatePayoutsRoute: AffiliatePayoutsRoute,AffiliateIndexRoute: AffiliateIndexRoute,AffiliateStatementIdRoute: AffiliateStatementIdRoute
}

const AffiliateRouteWithChildren = AffiliateRoute._addFileChildren(AffiliateRouteChildren)




const TeacherRouteChildren = {
  TeacherAiRoute: TeacherAiRoute,TeacherIndexRoute: TeacherIndexRoute,TeacherAssignmentsAssignmentIdRoute: TeacherAssignmentsAssignmentIdRoute,TeacherAssignmentsNewRoute: TeacherAssignmentsNewRoute,TeacherClassesClassIdRoute: TeacherClassesClassIdRoute,TeacherAssignmentsIndexRoute: TeacherAssignmentsIndexRoute,TeacherClassesIndexRoute: TeacherClassesIndexRoute
}

const TeacherRouteWithChildren = TeacherRoute._addFileChildren(TeacherRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRoute: AdminRoute,AffiliateRoute: AffiliateRouteWithChildren,AffiliatesRoute: AffiliatesRoute,AlgebraAiSolverRoute: AlgebraAiSolverRoute,AnalyticsHealthRoute: AnalyticsHealthRoute,BillingRoute: BillingRoute,CalculusAiSolverRoute: CalculusAiSolverRoute,ClassesRoute: ClassesRoute,CoachRoute: CoachRoute,EducationAdminRoute: EducationAdminRoute,ExamRoute: ExamRoute,FamilyRoute: FamilyRoute,FlashcardsRoute: FlashcardsRoute,FriendsRoute: FriendsRoute,GameRoute: GameRoute,HistoryRoute: HistoryRoute,IconDiagnosticsRoute: IconDiagnosticsRoute,LoginRoute: LoginRoute,NotificationsRoute: NotificationsRoute,OnboardingRoute: OnboardingRoute,OriginalityRoute: OriginalityRoute,PlannerRoute: PlannerRoute,PracticeRoute: PracticeRoute,PremiumStatusRoute: PremiumStatusRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,ProgressRoute: ProgressRoute,QuizRoute: QuizRoute,ReferralTermsRoute: ReferralTermsRoute,ReferralsRoute: ReferralsRoute,ResetPasswordRoute: ResetPasswordRoute,RunbookRoute: RunbookRoute,SchoolRoute: SchoolRoute,SecurityRoute: SecurityRoute,SecurityRunsRoute: SecurityRunsRoute,SettingsRoute: SettingsRoute,SignupRoute: SignupRoute,SnapCapiRoute: SnapCapiRoute,StudentRoute: StudentRoute,SubscriptionRoute: SubscriptionRoute,SubscriptionStatusRoute: SubscriptionStatusRoute,SupportRoute: SupportRoute,TeacherRoute: TeacherRouteWithChildren,TermsRoute: TermsRoute,UpgradeRoute: UpgradeRoute,UsageRoute: UsageRoute,AssignmentsAssignmentIdRoute: AssignmentsAssignmentIdRoute,AuthCallbackRoute: AuthCallbackRoute,CheckoutReturnRoute: CheckoutReturnRoute,DebugReportTokenRoute: DebugReportTokenRoute,AssignmentsIndexRoute: AssignmentsIndexRoute,CoursesIndexRoute: CoursesIndexRoute,CoursesCourseSlugLessonSlugRoute: CoursesCourseSlugLessonSlugRoute,CoursesCourseSlugIndexRoute: CoursesCourseSlugIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)